import script from "./AnnouncementSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementSection.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementSection.vue?vue&type=style&index=0&id=2c1eb81a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1eb81a"]])

export default __exports__